/*
  Skin Clique: keeps the buy box shipping message in step with the selected variant and
  purchase option.

  snippets/product-block-buy-buttons.liquid renders [data-sc-shipping-message] with both messages
  and a [data-sc-net-prices] JSON map: variant id to { one_time, plans: { selling plan id: price } },
  all in cents. one_time is after the custom.sale_price markdown; plan prices are the selling plan
  allocation prices (the subscription minimum is the same as one-time). At or above
  data-threshold the item ships free; below it the message states the free shipping threshold.

  The selected plan is read from the Shopify Subscriptions app block, the same way
  subscription-strikethrough.js does: the checked [data-radio-type] input in the visible block,
  whose data-selling-plan-id names the plan.
*/
(function () {
  if (window.scShippingMessageLoaded) return;
  window.scShippingMessageLoaded = true;

  function selectedPlanId(scope) {
    var visibleBlock = scope.querySelector(
      '.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)'
    );
    var checked = visibleBlock && visibleBlock.querySelector('input[data-radio-type]:checked');
    if (checked && checked.dataset.radioType === 'selling_plan') {
      return checked.dataset.sellingPlanId || null;
    }
    return null;
  }

  function update() {
    document.querySelectorAll('[data-sc-shipping-message]').forEach(function (messageEl) {
      var policies = messageEl.closest('[data-product-policies]');
      var json = policies && policies.querySelector('script[data-sc-net-prices]');
      var scope = messageEl.closest('[data-section-type]') || document;
      var select = scope.querySelector('[data-variant-select]');
      if (!json || !select) return;

      var prices;
      try {
        prices = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }

      var entry = prices[select.value];
      if (!entry) return;

      var planId = selectedPlanId(scope);
      var net = entry.one_time;
      if (planId && entry.plans && typeof entry.plans[planId] === 'number') {
        net = entry.plans[planId];
      }
      if (typeof net !== 'number') return;

      var text =
        net >= Number(messageEl.dataset.threshold)
          ? messageEl.dataset.shipsFree
          : messageEl.dataset.belowThreshold;
      if (messageEl.textContent !== text) messageEl.textContent = text;

      watchSubscriptionBlock(scope);
    });
  }

  // The subscriptions widget renders after load and swaps which block is visible on a variant
  // change by toggling classes, so watch it like subscription-strikethrough.js does.
  function watchSubscriptionBlock(scope) {
    var container = scope.querySelector('.shopify_subscriptions_app_container');
    if (!container || container.hasAttribute('data-sc-shipping-watched')) return;
    container.setAttribute('data-sc-shipping-watched', '');
    new MutationObserver(update).observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  // Variant and purchase option changes. The theme selects the new variant in
  // [data-variant-select] and then dispatches a non-bubbling change event on the product form;
  // a capture listener still sees it.
  document.addEventListener(
    'change',
    function () {
      window.setTimeout(update, 0);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
